import { config, createInertiaApp } from '@inertiajs/svelte'
import { mount } from 'svelte'

// Rack parses indexed FormData keys (a[0][b]) as index-keyed hashes, not arrays —
// use bracket format (a[][b]) so array params survive file-upload submissions.
config.set('form.forceIndicesArrayFormatInFormData', false)

import '../admin_site/stylesheets/application.css'
import { applyTheme, loadTheme } from '../admin_site/lib/theme.js'

// Apply the saved light/dark/auto preference before Inertia mounts so there is
// no flash of the wrong theme.
applyTheme(loadTheme())

import Chart from 'chart.js/auto'
window.Chart = Chart

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../admin_site/pages/**/*.svelte', {
      eager: true,
    })
    return pages[`../admin_site/pages/${name}.svelte`]
  },

  setup({ el, App, props }) {
    mount(App, { target: el, props })
  },
  progress: {
    delay: 250,
    color: '#29d',
    includeCSS: true,
    showSpinner: false,
  }
})
